<template>
	<el-form @submit.native.prevent="submit" :model="model" ref="form">
		<el-image :src="sentauro" />

		<h1 class="text-center">Inicio de sesión</h1>

		<el-form-item prop="username">
			<span class="form-label">Usuario *</span>
			<el-input size="large" autocomplete="off" placeholder="Ingrese usuario" v-model="model.username" :prefix-icon="User" />
		</el-form-item>

		<el-form-item prop="password">
			<span class="form-label">Contraseña *</span>
			<el-input size="large" autocomplete="new-password" placeholder="Ingrese contraseña" v-model="model.password" :prefix-icon="Lock" type="password" show-password />
		</el-form-item>

		<el-alert v-if="model.error" :title="model.error" type="error" center show-icon :closable="false" />

		<el-button :loading="model.loading" size="large" type="success" native-type="submit" round>Continuar</el-button>
	</el-form>
</template>

<script setup>
	import { reactive, ref } from 'vue';
	import { User, Lock } from '@element-plus/icons-vue';
	import sentauro from '@/assets/svg/sentauro1.svg';

	/* refs */
	const form = ref(null);

	/* submit */
	const submit = async () => {
		if (!model.username) return (model.error = 'Debes ingresar el usuario');

		if (!model.password) return (model.error = 'Debes ingresar la contraseña');

		model.loading = true;

		const formData = new FormData();
		formData.append('username', model.username);
		formData.append('password', model.password);

		let res = await fetch('/login', {
			method: 'post',
			body: formData,
		});

		if (res.status === 200) {
			res = await res.json();
			window.location = '/';
		} else {
			model.loading = false;
			res = await res.json();
			model.error = res.error;
		}
	};

	/* model */
	const model = reactive({
		username: '',
		password: '',
		error: '',
		loading: false,
	});
</script>
